import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from './config.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config;

  constructor(private http: HttpClient, private configService: ConfigService) { }

  async loadConfig(): Promise<void> {
    if (!this.configService.configs) {
      await this.configService.load();
    }

    const apiUrl = `${this.configService.configs.apiBaseUrl}/v2/${environment.organizationDetails}`;
    try {
      const result: any = await firstValueFrom(this.http.get(apiUrl));
      if (result.status) {
        this.config = result.data;
      }
    } catch (error) {
      this.config = null;
    }
  }

  get appConfig() {
    return this.config;
  }
}
